import React from 'react';
import _ from 'underscore';

import { Location } from '~common/react/Location';
import { imgPath } from '~common/utilities/ImgUrl';
import { BrowserTitleService } from '~commonInfra/services/BrowserTitleService';
import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';
import { ExplorerStyles } from '~src/spacesPlatform/components/Explorer/ExplorerStyles';
import { ExplorerEmptyStateProps } from '~src/spacesPlatform/components/Explorer/widgets/ExplorerEmpyState';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { Messages } from '../../codegen/Localize';
import { ProjectDefinition } from '../../contentDefinitions/ProjectDefinition';

export interface RecentsSpaceStateProps {
  readonly urls: SpacesSiteUrls;
}

export interface RecentsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export interface RecentsSpaceOwnProps {
  readonly siteName: string;
}

export type RecentsSpaceProps = RecentsSpaceStateProps & RecentsSpaceDispatchProps & RecentsSpaceOwnProps;

export class RecentsSpace extends React.PureComponent<RecentsSpaceProps> {
  public componentDidMount() {
    this.props.requestSpaceContents();
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.recentsBrowserTitle() });
  }

  public componentDidUpdate(prevProps: RecentsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <div className={ SpaceContainerStyles.MastheadArea }>
          <div className={ExplorerStyles.SpaceHeaderContent}>
            <div className={ExplorerStyles.SpaceHeaderText}>{Messages.recentsBrowserTitle()}</div>
          </div>
        </div>
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={ProjectDefinition.supportedDisplayModes}
            emptyStateProps={this.emptyStateProps()}
            toolbarProps= {{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled'
            }}
          />
        </div>
      </div>
    );
  }

  private emptyStateProps(): ExplorerEmptyStateProps {
    return {
      iconUrl: imgPath('spaces_empty_recent.svg'),
      primaryMessage: Messages.recentsEmptyStatePrimary(),
      secondaryMessage: Messages.recentsEmptyStateSecondary(),
      onActionButton: this.onNoContentAction,
      actionButtonMessage: Messages.emptyStateCallToAction()
    };
  }

  private onNoContentAction = (): void => {
    Location.instance.setUrl(this.props.urls.exploreUrl());
  }
}
